/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .tag-editor-background[_ngcontent-%COMP%]{z-index:20000;position:fixed;top:0;left:0;width:100%;height:100vh;background:rgba(0,0,0,.1)}[_nghost-%COMP%]   .tag-editor-background[_ngcontent-%COMP%]   cc-row-tags-editor[_ngcontent-%COMP%], [_nghost-%COMP%]   .tag-editor-background[_ngcontent-%COMP%]   cc-tag[_ngcontent-%COMP%]{position:absolute}"];
export { styles as styles };
